import React from 'react';
import { AppThemeProvider } from './theme';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';

const App: React.FC = () => (
    <AppThemeProvider>
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    </AppThemeProvider>
);

export default App;
